<template>
  <div class="z-main">
	<div class="z-body" :style="{top:'0px',height:(windowHeight-48)+'px'}">
		<div class="z-body-in">
		<div class="my-header-box-out">
			<div class="my-header-box" :style="{ 'backgroundImage':'url('+ headerBoxImage +')' }">
				<div class="my-header">
			        <div style="font-size:22px;font-family: Source Han Sans CN;font-weight: bold;">
			            {{$t('我的')}}
			        </div>
			        <div></div>
			        <div></div>
			    </div>
			    <div style="padding:0px 15px 20px 15px;color:#ffffff;background: #000;">
					<div class="my-info" :style="{ 'backgroundImage':'url('+ headerImage +')' }">
					  <section style="display: flex;display: -webkit-flex;padding:0px 10px;">
						<div style="margin-right:20px;position:relative;">
						  <div :style="{
							  	width: '80px',
							  	height: '80px',
							  	borderRadius: '50%',
							  	border:'1px solid #515151',
							  	backgroundPosition:'center',
							  	backgroundSize:'100% 100%',
							  	backgroundImage:'url('+mine.avatar+')'
						  	}"></div>
						  <!-- <img style="width: 60px;height: 60px;border-radius: 50%" :src="mine.avatar"> -->
						  <input type="file" @change="handleFile($event)" style="position:absolute;width: 60px;height: 60px;left:0;right:0;top:0;bottom:0;z-index:999;opacity:0;">
						</div>
						<div>
						  <p style="padding:5px 0;font-size:18px;margin-bottom:0px;">{{mine.nickname}}</p>
						  <p style="margin-bottom:0px;font-size:14px;color:#a0a0a0;">ID：{{mine.uid}}</p>
						  <p style="margin-bottom:0px;font-size:14px;color:#a0a0a0;">{{$t('邮箱')}}：{{mine.email}}</p>
						</div>
					  </section>
					  <section style="margin-top:15px;border-top:1px solid #515151;">
						<div class="personContentBox" style="padding:0px;border-bottom:0px;padding-top:10px;">
						  <div>
							<div class="fontOrgan" style="font-size:18px;">{{amount_before}}{{mine.amount||0}}{{amount_after}}</div>
							<div style="font-size:14px;">{{$t('资产')}}</div>
						  </div>
						  <div style="color:#515151;">|</div>
						  <div>
							<div class="fontOrgan" style="font-size:18px;">{{amount_before}}{{fyprice}}{{amount_after}}</div>
							<div style="font-size:14px;">{{$t('持仓盈利')}}</div>
						  </div>
						</div>
					  </section>
				  	</div>
			  	</div>
			</div>
		</div>
	  <section class="z-my-list">
	  	<!-- <div>
	  		<router-link to="/my/transfer">
				<img class="z-my-left-icon" src="../assets/my/transfer2.png">
				<span>{{amount_text}}{{$t('转账')}}</span>
				<img class="z-my-right-icon" src="../assets/my/to_right.png">
		  	</router-link>
		</div> -->
		<div>
	  		<router-link to="/my/recharge">
				<img class="z-my-left-icon" src="../assets/my/money_in.png">
				<span>{{amount_text}}{{$t('入金')}}</span>
				<img class="z-my-right-icon" src="../assets/my/to_right.png">
		  	</router-link>
		</div>
		<div>
	  		<router-link :to="{path: mine.isset_credential ? '/my/withdraw' : '/my/paypwd?s=2'}">
				<img class="z-my-left-icon" src="../assets/my/money_out.png">
				<span>{{amount_text}}{{$t('出金')}}{{mine.isset_credential ? '' : '（'+$t('请先设置支付密码')+'）'}}</span>
				<img class="z-my-right-icon" src="../assets/my/to_right.png">
			</router-link>
		</div>

	  </section>
	  <section class="z-my-list">
			<!-- <div>
				<router-link to="/my/addSubAccount">
					<img class="z-my-left-icon" src="../assets/my/add-account.png">
					<span>新增账户</span>
					<img class="z-my-right-icon" src="../assets/my/to_right.png">
				</router-link>
			</div>
			<div>
				<router-link to="/my/batchActiveAccount">
					<img class="z-my-left-icon" src="../assets/my/batchActiveAccount.png">
					<span>批量激活</span>
					<img class="z-my-right-icon" src="../assets/my/to_right.png">
				</router-link>
			</div>
			<div>
				<router-link to="/my/publish">
					<img class="z-my-left-icon" src="../assets/my/publish.png">
					<span>美金挂卖</span>
					<img class="z-my-right-icon" src="../assets/my/to_right.png">
				</router-link>
			</div>
			<div>
				<router-link to="/my/publishBuyRecord">
					<img class="z-my-left-icon" src="../assets/my/trade_log.png">
					<span>交易记录</span>
					<img class="z-my-right-icon" src="../assets/my/to_right.png">
				</router-link>
			</div>
			<div>
				<router-link to="/my/levelQuery">
					<img class="z-my-left-icon" src="../assets/my/msg.png">
					<div>平级查询</div>
					<img class="z-my-right-icon" src="../assets/my/to_right.png">
				</router-link>
			</div> -->
	  	<div v-if="mine.spread==1">
		  <router-link :to="{path:'/my/share',query:extend}" >
			<img class="z-my-left-icon" src="../assets/my/share.png">
			<span>{{$t('推广码')}}</span>
			<img class="z-my-right-icon" src="../assets/my/to_right.png">
		  </router-link>
		</div>
		<!-- <div>
		  <router-link to="/my/transactionRecord">
			<img class="z-my-left-icon" src="../assets/my/trade_log.png">
			<span>{{$t('交易记录')}}</span>
			<img class="z-my-right-icon" src="../assets/my/to_right.png">
		  </router-link>
		</div> -->
		<div>
			<router-link to="/my/changePassWord">
			  <img class="z-my-left-icon" src="../assets/my/repwd.png">
			  <div>{{$t('修改登录密码')}}</div>
			  <img class="z-my-right-icon" src="../assets/my/to_right.png">
			</router-link>
		  </div>
		<div>
			<router-link to="/my/paypwd">
			  <img class="z-my-left-icon" src="../assets/my/paypwd.png">
			  <div>{{$t('修改支付密码')}}</div>
			  <img class="z-my-right-icon" src="../assets/my/to_right.png">
			</router-link>
		  </div>
		  <div>
			<router-link to="/my/realName">
			  <img class="z-my-left-icon" src="../assets/my/sm.png">
			  <div>{{$t('实名认证')}}</div>
			  <img class="z-my-right-icon" src="../assets/my/to_right.png">
			</router-link>
		  </div>
		</section>
	  <section class="z-my-list">
		<!-- <div>
		  <router-link :to="{path:'/my/withdraw',query:{from:'my'}}">
			<img class="z-my-left-icon" src="../assets/my/trade_log.png">
			<span>钱包</span>
			<img class="z-my-right-icon" src="../assets/my/to_right.png">
		  </router-link>
		  <div class="z-index-left-amount z-flex bg-color dark-color">
			<div class="z-flex">
			  <span v-text="mine.profit" class="z-index-left-amount-item"></span>
			  <span>盈利分成</span>
			</div>
			<div class="z-flex">
			  <span v-text="mine.extend" class="z-index-left-amount-item"></span>
			  <span>直推奖励</span>
			</div>
			<div class="z-flex">
			  <span v-text="mine.agent" class="z-index-left-amount-item"></span>
			  <span>代理佣金</span>
			</div>
			<div class="z-flex">
			  <span v-text="mine.owes" class="z-index-left-amount-item"></span>
			  <span>感恩奖励</span>
			</div>
			<div class="z-flex">
			  <span v-text="mine.passcard" class="z-index-left-amount-item"></span>
			  <span>通证奖励</span>
			</div>
		  </div>
		</div> -->
		<!-- <div >
		  <router-link :to="{path:'/index/keyOrder',query:{from:'/my'}}">
			<img class="z-my-left-icon" src="../assets/my/add-account.png">
			<span>一键下单</span>
			<img class="z-my-right-icon" src="../assets/my/to_right.png">
		  </router-link>
		</div>
		<div>
		  <router-link :to="{path:'/index/keyOrderEscrow',query:{from:'/my'}}">
			<img class="z-my-left-icon" src="../assets/my/batchActiveAccount.png">
			<span>一键托管</span>
			<img class="z-my-right-icon" src="../assets/my/to_right.png">
		  </router-link>
		</div> -->

		<!-- <div>
		  <router-link :to="{path:'/my/team',query:{}}">
			<img class="z-my-left-icon" src="../assets/my/_/trade_log.png">
			<span>团队</span>
			<img class="z-my-right-icon" src="../assets/my/to_right.png">
		  </router-link>
		</div>
		<div>
		  <router-link :to="{path:'/crm',query:{href:'recommend',title:'推广链接'}}">
			<img class="z-my-left-icon" src="../assets/my/_/out_gold.png">
			<span>推广码</span>
			<img class="z-my-right-icon" src="../assets/my/to_right.png">
		  </router-link>
		</div> -->

	  </section>
	  <section class="z-my-list">
		<div>
		  <router-link to="/my/feedbackFeedback">
			<img class="z-my-left-icon" src="../assets/my/fb.png">
			<span>{{$t('意见反馈')}}</span>
			<img class="z-my-right-icon" src="../assets/my/to_right.png">
		  </router-link>
		</div>

		<!-- <div>
		  <router-link to="index/gather">
			<img class="z-my-left-icon" src="../assets/my/publish.png">
			<div>账户资金一键归拢</div>
			<img class="z-my-right-icon" src="../assets/my/to_right.png">
		  </router-link>
		</div>
		<div>
		  <router-link to="index/subAccount">
			<img class="z-my-left-icon" src="../assets/my/publish.png">
			<div>切换子账户</div>
			<img class="z-my-right-icon" src="../assets/my/to_right.png">
		  </router-link>
		</div> -->
    <div class="z-my-exit" @click="isShowLang = true">
      <img class="z-my-left-icon" src="../assets/my/lang.png">
      <div>{{$t('语言切换')}}</div>
      <img class="z-my-right-icon" src="../assets/my/to_right.png">
    </div>
		<div class="z-my-exit" @click="service">
		  <img class="z-my-left-icon" src="../assets/my/service.png">
		  <div>{{$t('在线客服')}}</div>
		  <img class="z-my-right-icon" src="../assets/my/to_right.png">
		</div>
		<div class="z-my-exit" @click="exit">
		  <img class="z-my-left-icon" src="../assets/my/out.png">
		  <div>{{$t('安全退出')}}</div>
		  <img class="z-my-right-icon" src="../assets/my/to_right.png">
		</div>
	  </section>
	</div>
	</div>

	<!-- 语言选择弹框 -->
	<v-dialog v-model="isShowLang" max-width="290">
	  <v-card light>
		<v-card-title>{{$t('提示')}}</v-card-title>
		<v-card-text>
			<div class="z-my-lang">
				<div :style="{color:currLang=='en'?'red':''}" @click="langChange('en')">{{$t('英文')}}</div>
				<div :style="{color:currLang=='zh'?'red':''}" @click="langChange('zh')">{{$t('中文简体')}}</div>
			</div>
		</v-card-text>
		<v-card-actions>
		  <v-spacer></v-spacer>
		  <v-btn color="green darken-1" flat="flat" @click="isShowLang=false">{{$t('关闭')}}</v-btn>
		</v-card-actions>
	  </v-card>
	</v-dialog>

	<!-- 底部菜单 -->
	<ButtomMenu active="3" />
  </div>
</template>

<script>
  import ButtomMenu from '../components/ButtomMenu'
  export default {
	name: 'my',
	components: {
	  ButtomMenu
	},
	inject: ['reload'],
	data() {
	  return {
	  	headerBoxImage:require('../assets/my/header-box.png'),
	  	headerImage:require('../assets/my/header-yj.png'),
		mine: {
		  id: 0, //用户id
		  avatar:'',
		  nickname: this.$t('请先登录'), //用户名称
		  amount:0,
		  win_money:0,
		},
		fyprice:0, // 浮盈
		extend:null,
		isShowLang: false,
		currLang: this.$i18n.locale,
		//持仓轮询发送
		holdSendLoop:null
	  }
	},
	mounted() {
		let _this = this;
		_this.holding()
		//轮询发送持仓
		_this.holdSendLoop = setInterval(function() {
			_this.holding()
		}, 2000)
	},
	created() {
		this.doInit()
	},
	destroyed() {
	  let _this = this;
	  clearInterval(_this.holdSendLoop)
	},
	methods: {
		holding:function () {
			let _this = this
			_this.post('api/Trade/Holding.html', {}).then((rs) => {
				if (rs.code == 0) {

					// _this.fyprice = rs.data.money.amount
					let fyprice = 0;
					rs.data.list.forEach(function (item,index) {
						fyprice = _this.zmath.add(fyprice,item.fyprice)
					})
					_this.fyprice = fyprice
				}
			})
		},
		doInit:function () {
			//会员信息
			this.get('api/users/center', {}).then((res) => {
				if (res.code == 0) {
					this.mine = res.data
					this.extend = res.data.extend
				}
				else {
				  this.$store.commit('layer', res.msg)
				}
			})
		},
	  //头像上传
	  handleFile: function(event) {
		event.preventDefault();
		var _this = this;
		let file = event.target.files[0];
		// 看支持不支持FileReader
		if (!file || !window.FileReader) return;
		if (/^image/.test(file.type)) {
		  // 创建一个reader
		  let reader = new FileReader();
		  // 将图片将转成 base64 格式
		  reader.readAsDataURL(file);
		  // 读取成功后的回调
		  reader.onloadend = function() {
			_this.mine.avatar = this.result;
		  }
		}
		let formData = new FormData();
		formData.append('file', file);
		formData.append('token', _this.getToken());
		_this.upload('api/member/upFile.html', formData).then((res) => {
		  if (res.code == 0) {
			_this.mine.avatar = res.data
			_this.post('api/Member/changeAvatar.html', {
			  avatar: _this.mine.avatar
			}).then((res2) => {
			  _this.$store.commit('layer', res2.msg)
			})
		  } else {
			_this.$store.commit('layer', res.msg)
		  }
		})
	  },
	  // 安全退出
	  exit: function() {
		let _this = this
		this.post('api/Users/Logout.html', {}).then((res) => {
		  this.$store.commit('layer', res.msg)
		  if (res.code == 0) {
			this.removeToken()
			_this.jump('/user/login')
		  }
		})
	  },
	  // 语言切换 en ,  zn 两种值
	  langChange:function (value) {
	  	let _this = this
	  	// alert('value='+value)
	  	let to_lang = _this.getLangList()[value]['changeValue']
	  	// alert('111')
	  	_this.setLang(value)
	  	_this.isShowLang = false
	  	// alert('222')
	  	// console.log(typeof window.Android)
	  	if ('undefined' != typeof window.Android) {
	  		// alert('333')
	  		window.Android.switchLanguageRefresh()
	  	}
	  	else {
	  		// alert('444')
	  		location.reload()
	  	}
	  },
    service(){
      window.location.href = "https://t.me/DOX0100";
    },

	}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.z-my-lang {
	font-size: 16px;
	font-weight: 550;
}
.z-my-lang div{
	padding-top: 10px;
}
.my-header-box-out {
	background:#F5F5F5;
}
.my-header-box {
	background-size:100% 100px;
	background-position:top;
}
.my-header {
	display: -webkit-flex;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    font-size: 16px;
     color: white;
    padding: 0 10px;

}
.my-info {
	background-size:100% 100%;
	width: 100%;
	position: relative;
	padding: 20px 15px;
}
  a {
	color: white;
	text-decoration: none;
  }

  .fontOrgan {
	color: orange;
  }

  .personContentBox {
	display: flex;
	justify-content: space-around;
	align-items: center;
	padding: 0px 0 14px 0;
	border-bottom: 2px solid #515151;
  }

  .personContentBox>div {
	width: 33%;
	text-align: center;
  }

  .btnAction {
	background-color: rgb(201, 67, 63);
  }

  .btnBox {
	display: flex;
	justify-content: space-between;
	font-size: 12px;
  }

  .btnBox>div {
	text-align: center;
	width: 33%;
	background-color: #424355;
	border-bottom: 2px solid #28293D;
	padding: 6px;
  }

  .btnBox>div img {
	width: 27px;
	height: 27px;
  }

  .fooldBox {
	display: flex;
	justify-content: space-around;
	align-items: center;
	position: absolute;
	bottom: 0px;
	width: 100%;
	background-color: #28293D;
	padding: 2px 0 2px 0;
	border-top: 1px solid #424355;
  }

  .fooldBox>div>img {
	width: 26px;
	height: 26px;
  }

  .z-my-list {
	padding: 0 10px;
  }

  .z-my-list>div {
	padding: 18px 0;
	border-bottom: 1px solid #515151;
  }

  .z-my-list>div:last-child {
	/* border-bottom: 0px; */
  }

  .z-my-exit,
  .z-my-list>div>a {
	display: flex;
	display: -webkit-flex;
	align-items: center;
	color: #fff;
  }

  .z-my-exit {
	/* border-bottom: 1px solid #313439!important; */
  }

  .z-my-left-icon {
	width: 20px;
	margin-right: 15px;
  }

  .z-my-right-icon {
	margin-left: auto;
	width: 10px;
  }

  .z-My-inglod-type {
	padding: 10px;
	font-size: 16px;
	justify-content: center;
  }

  .z-My-inglod-type img {
	width: 20px;
  }

  .z-index-left-amount {
	background: #21222D;
	margin: 10px;
	padding: 10px;
	border-radius: 5px;
  }

  .z-index-left-amount-item {
	font-size: 18px;
	color: #DCB77C;
  }

  .z-index-left-amount div {
	flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/pages/my.vue